import { Link } from 'react-router-dom';
import { useI18n } from './i18n';
import { telHref, PHONE_DISPLAY } from './phone';
import './App.css';

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="os-titleblock">
      <div className="os-titleblock-in">
        <dl className="os-titleblock-grid">
          <div>
            <dt>{t('footer.company')}</dt>
            <dd>OrtoSoft SASU</dd>
          </div>
          <div>
            <dt>{t('footer.contact')}</dt>
            <dd>
              <a href={telHref}>{PHONE_DISPLAY}</a> ·{' '}
              <a href="mailto:contact@ortosoft.fr">contact@ortosoft.fr</a>
            </dd>
          </div>
          <div>
            <dt>{t('footer.legal')}</dt>
            <dd>
              <a href="cgv.pdf" target="_blank" rel="noreferrer">{t('footer.cgv')}</a> ·{' '}
              <Link to="/ml">{t('footer.ml')}</Link>
            </dd>
          </div>
          <div>
            <dt>{t('footer.ref')}</dt>
            <dd>© 2021 – 2027 — ortosoft.fr</dd>
          </div>
        </dl>
      </div>
    </footer>
  );
}
